import _ from 'lodash'

import Project from '@/models/project'

import defaultSegmentKeymap from '@/schemes/default/segment-keymap'

/**
 * @type {ImprovementsVuexState}
 */
const initialState = {
    /** @type {Project} **/
    currentProject: new Project(),

    improvementFilters: {
        recommended: false,
        selected: false,
    },
    loadFailed: false,
    improvementCalculationState: -1,
    savings: [],

    /** @type {Array<{ key: string, visible: boolean }>} **/
    visibleSegments: defaultSegmentKeymap.filter(km => km.key !== 'summary').map(km => {
        return { key: km.key, visible: true }
    }),
}

/**
 * @type {ImprovementsVuexState}
 */
const state = _.cloneDeep(initialState)

export { initialState }

export default state
